// cspell: ignore undoable
import { Component, Inject, OnInit } from "@angular/core";

import { MatDialog } from "@angular/material/dialog";
import { ChartBindingObject } from "@tylertech/charting-module";

import { ToastService } from "@tylertech/core-module";
import { ICustomViewComponent } from "@tylertech/custom-view";

import { TodoItemDTO } from "../../interfaces";
import { UBDashboardService } from "../../services/";
import { AddTodoItemDialogComponent } from "../dialogs/addTodoItemDialog.component";
import { IntentService } from "@tylertech/intents-module";
import { PacketService } from "../../../../packets/src/services/packet.service";

// TODO - this ain't no chart....
@Component({
    selector: "utilities-todo-card",
    templateUrl: "./utilitiesTodoCard.tmpl.html",
    styleUrls: [
        "./utilitiesTodoCard.component.scss"
    ],
    standalone: false
})
export class UtilitiesTodoCardComponent implements OnInit, ICustomViewComponent<ChartBindingObject>
{
    readonly customDataBinding: ChartBindingObject;
    initialCount: number = 5;

    isSaving: boolean = false;

    items: TodoItemDTO[] = [];

    showCount: number;

    private undoableItems: TodoItemDTO[] = [];

    constructor(
        private readonly $toastService: ToastService,
        private readonly $ubDashboardService: UBDashboardService,
        private readonly matDialog: MatDialog,
        private readonly $intentService: IntentService,
        private readonly $packetService: PacketService,
    )
    { }

    ngOnInit(): void
    {
        this.loadItems();
    }

    get canUndo(): boolean
    {
        return this.undoableItems?.length !== 0;
    }

    get displayItems(): Array<TodoItemDTO>
    {
        return this.items.slice(0, this.showCount);
    }

    get canShowMore(): boolean
    {
        return this.items.length > this.showCount;
    }

    get hasItems(): boolean
    {
        return (this.items?.length || 0) !== 0;
    }

    isCustom(item: TodoItemDTO): boolean
    {
        return (item.EntityType === "Custom");
    }

    addTodo(): void
    {
        const dialogRef = this.matDialog.open(AddTodoItemDialogComponent);
        dialogRef.afterClosed().toPromise()
            .then((result: TodoItemDTO) =>
            {
                if (!result)
                {
                    return;
                }

                this.items.push(result);
                this.loadItems();
            });
    }

    completed(item: TodoItemDTO): void
    {
        item.Saving = true;
        item.Completed = true;
        this.$ubDashboardService.saveTodoItem(item)
            .then(_result =>
            {
                item.Saving = false;
                this.undoableItems.push(item);
                this.$toastService.showToast("Todo Item Completed");
                this.filterCompleted();
            });
    }

    private filterCompleted(): void
    {
        this.items = this.items.filter(x => !x.Completed);
    }

    private loadItems(): void
    {
        const self = this;
        this.$ubDashboardService.getTodoItems()
            .then(result =>
            {
                self.items = result;
                self.order();
                this.setShowCount(this.initialCount);
            });
    }

    private openEntity(_item: TodoItemDTO): void
    {
        switch (_item.EntityType)
        {
            case "UB.Account": {
                this.$intentService.resolve("OpenUBAccount", "Open", { id: _item.EntityId });
                break;
            }
            case "UB.ServiceOrder": {
                this.$intentService.resolve("OpenUBServiceOrder", "Open", { id: _item.EntityId });
                break;
            }
            case "CC.Packet": {
                this.$packetService.GetProcessIdByPacketId(_item.EntityId)
                    .then((processId: string) =>
                    {
                        this.$intentService.resolve("OpenProcessing", "Open", { ProcessId: processId });
                    });
                break;
            }
            default: {
                break;
            }
        }
    }

    pastDue(item: TodoItemDTO)
    {
        let answer = new Date(item.DueDate) < new Date(Date.now()) ? "red-font" : "";
        return answer;
    }

    order(): void
    {
        this.items.sort((a1, a2) =>
        {
            if (new Date(a1.DueDate) > new Date(a2.DueDate))
            {
                return 1;
            }
            else if (new Date(a1.DueDate) < new Date(a2.DueDate))
            {
                return -1;
            }
            return 0;
        });
    }

    getClass(item: TodoItemDTO): Record<string, boolean>
    {
        /* eslint-disable @typescript-eslint/naming-convention */
        return {
            "red-font": new Date(item.DueDate) <= new Date()
        };
        /* eslint-enable @typescript-eslint/naming-convention */
    }

    setShowCount(count: number): void
    {
        this.showCount = count;
        if ((this.items?.length || 0) < this.showCount)
        {
            this.showCount = this.items.length;
        }
    }

    showMore($event?: MouseEvent): void
    {
        if ($event !== undefined)
        {
            $event.stopPropagation();
        }
        this.setShowCount(this.showCount + this.initialCount);
    }

    undo(): void
    {
        const self = this;
        const item = this.undoableItems.pop();
        item.Completed = false;
        this.$ubDashboardService.saveTodoItem(item)
            .then(_result =>
            {
                self.items.push(item);
                self.filterCompleted();
                self.order();
            });
    }

    getAriaLabel(item: TodoItemDTO): string
    {
        return `Submission-Complete-${item.EntityNumber}-ToDo-UtilityBilling`;
    }
}
